import {Outlet} from 'react-router-dom';
import {HubspotChatWidget} from '@/components/shared/hubspot/HubspotChatWidget';

export function RootElement() {
    return (
        <>
            <Outlet/>
            <HubspotChatWidget />
        </>
    );
}


